<template>
	<div class="navigation">
		<div class="navigation__inner disable-scrollbars">
			<div class="navigation__content">
				<img src="@/assets/img/logo.png" alt="pointaart" />
				<ul class="navigation__list">
					<li
						v-for="navigationItem in navigationItems"
						:key="navigationItem.content_id"
						class="navigation__list-item"
					>
						<router-link :to="navigationItem.url" class="navigation__link">
							{{ navigationItem.menu_title }}
						</router-link>
					</li>
				</ul>
				<h1>{{ store.navTitle }}</h1>
				<div class="navigation__description" v-html="store.navContent"></div>
				<div class="navigation__footer">
					<ul class="navigation__list">
						<li class="navigation__list-item">
							<a href="mailto:jitka.emlerova@seznam.cz">
								<img
									class="navigation__icon"
									src="@/assets/img/icons/at-sign.svg"
									alt="email"
								/>
								<span>jitka.emlerova@seznam.cz</span>
							</a>
						</li>
						<li class="navigation__list-item">
							<img
								class="navigation__icon"
								src="@/assets/img/icons/phone.svg"
								alt="phone"
							/>
							<span>608 845 890</span>
						</li>
						<li class="navigation__list-item">
							<a href="https://www.facebook.com/projekty.zahrad/">
								<img
									class="navigation__icon"
									src="@/assets/img/icons/facebook.svg"
									alt="facebook"
								/>
								<span>Náš facebook</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from "@/store";
import "./Navigation.scss";

export default {
	name: "Navigation",
	data() {
		return {
			store: store.state,
			navigationItems: []
		};
	},
	mounted() {
		this.navigationItems = store.state.content["menu"];
	}
};
</script>
